+function ($) {

	"use strict";

	var body = $('body');

	var HamburgerMenu = function (toggle) {
		this.toggle = $(toggle);
		var data = this.toggle.data();
		this.menu = $(data.target);

		this.init();
	};

	HamburgerMenu.prototype = {
		constructor: HamburgerMenu,

		init: function () {
			this.menu.hammer();
			this.createOverlay().registerListeners();
		},

		createOverlay: function () {
			this.overlay = $('<div class="hamburger-menu-overlay"/>');
			this.overlay.hammer();
			this.overlay.appendTo(body);

			return this;
		},

		toggleMenu: function () {
			if (this.menu.hasClass('collapse')) {
				this.openMenu();
			}
			else {
				this.closeMenu();
			}

			return this;
		},

		openMenu: function () {
			body.addClass('mobile-menu-open');
			this.toggle.removeClass('collapsed');
			this.menu.removeClass('collapse');

			return this;
		},

		closeMenu: function () {
			var that = this;

			this.menu.addClass('collapse');

			this.menu.one(transitionEndEvent(), function () {
				body.removeClass('mobile-menu-open');
				that.toggle.addClass('collapsed');
			}).triggerTransitionEndFallback();

			return this;
		},

		registerListeners: function () {
			var that = this;

			this.toggle.on('click', $.proxy(this.toggleMenu, this));

			this.overlay.on('tap.hamburger', $.proxy(this.closeMenu, this));

			this.overlay.add(this.menu)
				.on('panstart.hamburger', function (event) {
					that.menuPanStart();
				})
				.on('panright.hamburger panleft.hamburger', function (event) {
					that.menuPan(event);
				})
				.on('panend.hamburger', function () {
					that.menuPanEnd();
				});

			return this;
		},

		menuPanStart: function () {
			this.setPanningState(true);
			this.menu.addClass('panning');
		},

		menuPan: function (event) {
			if (this.isPanning) {
				var translate;
				var menuWidth = this.menu.width();

				if (event.gesture.deltaX > 0) {
					translate = 0;
				}
				else if (event.gesture.deltaX < -menuWidth) {
					translate = -100;
				}
				else {
					translate = ((100 / menuWidth) * event.gesture.deltaX);
				}

				this.translate = translate;

				this.menu.css({
					'-webkit-transform': 'translateX(' + translate + '%)',
					'-moz-transform': 'translateX(' + translate + '%)',
					'transform': 'translateX(' + translate + '%)'
				});
			}

			return this;
		},

		menuPanEnd: function () {
			this.setPanningState(false);
			this.menu.removeClass('panning');

			this.menu.removeAttr('style');

			if (this.translate < -25) {
				this.closeMenu();
			}
		},

		setPanningState: function (state) {
			this.isPanning = state;
			return this;
		}
	};

	$(document).on('ready.hamburger', function () {
		$('[data-toggle=hamburger]').each(function () {
			return new HamburgerMenu(this);
		})
	});

}(window.jQuery);
